import "core-js/modules/esnext.iterator.map.js";
import { createNamespacedHelpers } from "vuex";
import PopDialog from "@components/popDialog.vue";
import Vue from "vue";
import vailcode from "@utils/errcode";
import moment from "moment";
import BigNumber from "bignumber.js";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  components: {
    PopDialog
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "connect", "address"])
  },
  props: {
    showRecordDialog: Boolean,
    recordType: Number
  },
  data() {
    return {
      recordList: [],
      logLoading: false,
      logHasMore: false,
      page: 1
    };
  },
  watch: {
    showRecordDialog: {
      handler(newVal, oldVal) {
        this.page = 1;
        if (newVal) {
          this.onLoadData(1);
        }
      },
      immediate: true
    }
  },
  methods: {
    checkScroll() {
      const scrollHeight = this.$refs.myScroll.scrollHeight;
      const scrollTop = this.$refs.myScroll.scrollTop;
      const clientHeight = this.$refs.myScroll.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        // 接近底部时触发加载
        if (this.logHasMore && !this.logLoading) {
          let page = this.page;
          this.onLoadData(page + 1);
        }
      }
    },
    closeDialog() {
      this.recordList = [];
      this.logLoading = false;
      this.logHasMore = false;
      this.$emit('closeDialog');
    },
    formatAmount(amount) {
      if (!amount) {
        return 0;
      }
      return BigNumber(amount).div(10 ** 18).decimalPlaces(0, BigNumber.ROUND_DOWN);
    },
    async onLoadData(page) {
      if (!this.address) {
        return;
      }
      if (this.logLoading) {
        return;
      }
      this.page = page;
      this.logLoading = true;
      let poolType = 'A';
      if (this.recordType === 2) {
        poolType = 'B';
      } else if (this.recordType === 3) {
        poolType = 'C';
      }
      let params = {
        page: page,
        pageSize: 15,
        "owner": this.address,
        "pool_type": poolType
      };
      // https://testapi.reflectionai.app/pool/logs?owner=0xF682158e0Fe1F9f891186A02494eB8c716b0FF91&pool_type=A&page=1&pageSize=15
      let rs = await Vue.prototype.$http.post("pool/logs", params);
      vailcode(rs, () => {
        rs.data.list.map(item => {
          console.log(item);
          item.showDateFormat = moment(item.created_at).format('yyyy-MM-DD HH:mm:ss');
          item.showAmount = BigNumber(item.amount).div(10 ** 18).decimalPlaces(0, BigNumber.ROUND_DOWN);
        });
        if (rs.data.pageNo == 1) {
          this.recordList = rs.data.list;
        } else {
          this.recordList = this.recordList.concat(rs.data.list);
        }
        if (rs.data.totalPage > rs.data.pageNo) {
          this.logHasMore = true;
        } else {
          this.logHasMore = false;
        }
        this.logLoading = false;
      }, () => {
        this.logLoading = false;
      });
    }
  }
};